import React from "react";
import { Box, Link, useMediaQuery } from "@mui/material";
import { FontSize } from "./types";
import { Link as ReactLink } from "react-router-dom";
import { theme } from "../../special/genie-theme/genie-theme";

interface GenieTextProps {
  fontSize?: FontSize;
  header?: boolean;
  paragraph?: boolean;
  fontWeight?: "normal" | "bold";
  children?: React.ReactNode;
  uppercase?: boolean;
  underline?: boolean;
  link?: string;
  subdued?: boolean;
  inline?: boolean;
  onClick?: () => void;
  style?: object;
  blank?: boolean;
}

const fontSizeMap: { [key in FontSize]: string } = {
  tiny: "0.75rem",
  small: "1rem",
  medium: "1.5rem",
  large: "2rem",
  huge: "2.5rem",
};

function GenieText({
  fontSize,
  header,
  fontWeight,
  paragraph,
  uppercase,
  children,
  link,
  subdued,
  inline,
  onClick,
  underline,
  style,
  blank,
}: GenieTextProps) {
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const sx = {
    marginTop: 0,
    fontWeight: fontWeight || "normal",
    fontSize: fontSize ? fontSizeMap[fontSize] : fontSizeMap.medium,
    textTransform: uppercase ? "uppercase" : "none",
    mb: paragraph ? (isMobile ? 1 : 2) : 0,
    display: inline ? "inline" : "block",
    color: link
      ? theme.palette.primary.main
      : subdued
      ? theme.palette.text.secondary
      : theme.palette.text.primary,
    ...style,
  };
  if (link) {
    return (
      <Link
        target={blank ? "_blank" : undefined}
        onClick={onClick}
        component={blank ? "a" : ReactLink}
        href={blank ? link : undefined}
        sx={{
          textDecoration: "none",
          transition: "color 0.2s ease-in-out",
          ":hover": {
            color: theme.palette.primary.dark,
            textDecoration: underline ? "underline" : "initial",
          },
          ...sx,
        }}
        to={link}
      >
        {children}
      </Link>
    );
  }
  return (
    <Box
      onClick={onClick}
      color={"text.primary"}
      component={header ? "h1" : paragraph ? "p" : "div"}
      sx={{
        ...sx,
        ":hover": {
          textDecoration: underline ? "underline" : "initial",
        },
      }}
    >
      {children}
    </Box>
  );
}

export default GenieText;
